import { render, staticRenderFns } from "./recyclable.vue?vue&type=template&id=0a107942&scoped=true&"
import script from "./recyclable.vue?vue&type=script&lang=js&"
export * from "./recyclable.vue?vue&type=script&lang=js&"
import style0 from "./recyclable.vue?vue&type=style&index=0&id=0a107942&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a107942",
  null
  
)

export default component.exports